import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { WEIGHT_BOLD } from "@hl/base-components/lib/theme/typography";
import { Text } from "@mantine/core";
const ApproveTransferWrappedDescription = ({ symbol, status }) => {
    const formatted = (_jsx(Text, { size: "sm", display: "inline", weight: WEIGHT_BOLD, children: symbol }));
    if (status === "PENDING") {
        return _jsxs(_Fragment, { children: ["Approving wrapped ", formatted, " tokens to be transferred"] });
    }
    if (status === "MINED") {
        return _jsxs(_Fragment, { children: ["Approved wrapped ", formatted, " tokens to be transferred"] });
    }
    if (status === "REJECTED") {
        return _jsxs(_Fragment, { children: ["Failed to approve wrapped ", formatted, " tokens to be transferred"] });
    }
    return _jsx(_Fragment, { children: "Unknown transaction status." });
};
export default ApproveTransferWrappedDescription;
